import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Servidor } from '../models/servidor';

@Injectable()
export class ServidorService {

  constructor(private httpClient: HttpClient) { }

  GetServidorAtivo(matricula: number): Observable<Servidor> {
    return this.httpClient.get<Servidor>(`/Servidorativo/GetServidorAtivo/${matricula}`);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/services/servidor.service.ts